import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>NOTE: This is the privacy policy page for Expenses Tracker (or Xpense Tracker) Android App.</p>
      <p>PRIVACY POLICY: This app does not collect, use, or share personal information.</p>
    </div>
  );
}

export default Privacy;